import request from '@/utils/request'

// 预约考试
export function applyExam(data) {
  return request({
    url: '/system/exam-rocord/apply',
    method: 'POST',
    data
  })
}

// 获取预约信息
export function getApply() {
  return request({
    url: '/system/exam-rocord/getApply',
    method: 'GET'
  })
}

// 取消预约
export function cancelApply() {
  return request({
    url: '/system/exam-rocord/cancle',
    method: 'GET'
  })
}

// 获取公司列表
export function getCompanyList() {
  return request({
    url: '/system/exam-company/list',
    method: 'GET'
  })
}

// 创建公司
export function createExamCompany(data) {
  return request({
    url: '/system/exam-company/create',
    method: 'POST',
    data
  })
}

// 是否已参加过性格考试
export function hasNatureExam() {
  return request({
    url: '/system/exam-rocord/hasNatureExam',
    method: 'GET'
  })
}

// 获取性格考试试题
export function getNatureExam(examId) {
  return request({
    url: '/system/exam-rocord/nature',
    method: 'GET',
    params: examId ? { examId } : {}
  })
}
